import {
  AC_Project_addRoleForUser_Request,
  AC_Project_addRoleForUser_Response,
  AC_Project_deleteRoleForUser_Request_Query,
  AC_Project_deleteRoleForUser_Response,
  AC_Project_getMyPermissions_Request_Query,
  AC_Project_getMyPermissions_Response,
  AC_Project_getMyRoles_Request_Query,
  AC_Project_getMyRoles_Response,
  AC_Project_getPublicUserDetail_Request_Query,
  AC_Project_getPublicUsers_Request_Query,
  AC_Project_getPublicUsers_Response,
  AC_Project_getUsers_with_Roles_Request_Query,
  AC_Project_getUsers_with_Roles_Response,
} from '../services/access_control/AC_Project';
import { getAxiosInstance } from '../../react/utils/networkUtil';

export const remote_ACLProject_getMyRoles = async (
  request: AC_Project_getMyRoles_Request_Query,
): Promise<AC_Project_getMyRoles_Response> => {
  const response = await getAxiosInstance().get('/api/acl-project-ext/my-roles', {
    params: request,
  });
  const data: any = response.data;
  return data;
};

export const remote_ACLProject_getMyPermissions = async (
  request: AC_Project_getMyPermissions_Request_Query,
): Promise<AC_Project_getMyPermissions_Response> => {
  const response = await getAxiosInstance().get('/api/acl-project-ext/my-permissions', {
    params: request,
  });
  const data: any = response.data;
  return data;
};

export const remote_ACLProject_getUsers_with_Roles = async (
  request: AC_Project_getUsers_with_Roles_Request_Query,
): Promise<AC_Project_getUsers_with_Roles_Response> => {
  const response = await getAxiosInstance().get('/api/acl-project-ext/users-with-roles', {
    params: request,
  });
  const data: any = response.data;
  return data;
};

export const remote_ACLProject_addRoleForUser = async (
  request: AC_Project_addRoleForUser_Request,
): Promise<AC_Project_addRoleForUser_Response> => {
  const response = await getAxiosInstance().post('/api/acl-project-ext/roles', request);
  const data: any = response.data;
  return data;
};

export const remote_ACLProject_deleteRoleForUser = async (
  request: AC_Project_deleteRoleForUser_Request_Query,
): Promise<AC_Project_deleteRoleForUser_Response> => {
  const response = await getAxiosInstance().delete('/api/acl-project-ext/roles', {
    params: request,
  });
  const data: any = response.data;
  return data;
};

export const remote_ACLProject_getPublicUsers = async (
  request: AC_Project_getPublicUsers_Request_Query,
): Promise<AC_Project_getPublicUsers_Response> => {
  const response = await getAxiosInstance().get('/api/acl-project-ext/public-users', {
    params: request,
  });
  const data: any = response.data;
  return data;
};

export const remote_ACLProject_getPublicUserDetail = async (
  request: AC_Project_getPublicUserDetail_Request_Query,
): Promise<AC_Project_getUsers_with_Roles_Response> => {
  const response = await getAxiosInstance().get('/api/acl-project-ext/public-user-detail', {
    params: request,
  });
  const data: any = response.data;
  return data;
};

export const ACLProjectAPIs = {
  remote_ACLProject_getMyRoles,
  remote_ACLProject_getMyPermissions,
  remote_ACLProject_getUsers_with_Roles,
  remote_ACLProject_addRoleForUser,
  remote_ACLProject_deleteRoleForUser,
  remote_ACLProject_getPublicUsers,
  remote_ACLProject_getPublicUserDetail,
};
